import React from "react";
import { CloudPlatformCard } from "../cloud-platform-card/cloud-platform-card";
import { useStyles } from "./style";
import { CloudPlatformProps } from "./types";
import classNames from "classnames";

export const CloudPlatform = (props: CloudPlatformProps) => {
    const classes = useStyles();

    return (
        <section className={classes.cloudPlatformContainer}>
            {props.title && <div className={"h1 " + classes.cloudPlatformTitle}>{props.title}</div>}
            {props.subtitle && <div className={"h4 " + classes.cloudPlatformSubtitle}>{props.subtitle}</div>}
            <div className={classes.cardsContainer}>
                {props.cards.map((el, idx) => (
                    <div className={classNames(classes.cardItem, el.classes ? el.classes  : "")} key={idx}>
                        {props.animationDisabled &&
                            <CloudPlatformCard
                                subtitle={el.subtitle}
                                title={el.title}
                                position={el.position}
                                img={el.img}
                                video={el.video}
                                body={el.body}
                                classes={el.classes}
                            />
                        }
                    </div>
                ))}
            </div>
        </section>
    );
};
